import { Controller } from 'stimulus';
import { disable, enable } from './aria_disabled_controller';

/**
 * Toggle `aria-disabled` on submit targets based on whether a select
 * target has a value. Mount on a form (or wrapping element) with a
 * `change` action so the submit reacts as the user picks/clears an option.
 */
export default class extends Controller {
  static targets = ['select', 'submit'];

  connect() {
    this.update();
  }

  update() {
    const hasValue = Boolean(this.selectTarget.value);

    this.submitTargets.forEach((submit) => {
      if (hasValue) {
        enable(submit);
      } else {
        disable(submit);
      }
    });
  }
}
